__turbopack_context__.v({
  "axisBlock": "SizeSelection-module-scss-module__aVyYvW__axisBlock",
  "axisLabel": "SizeSelection-module-scss-module__aVyYvW__axisLabel",
  "buttonGrid": "SizeSelection-module-scss-module__aVyYvW__buttonGrid",
  "container": "SizeSelection-module-scss-module__aVyYvW__container",
  "dropdownTriggerError": "SizeSelection-module-scss-module__aVyYvW__dropdownTriggerError",
  "dropdownTriggerFullWidth": "SizeSelection-module-scss-module__aVyYvW__dropdownTriggerFullWidth",
  "errorMessage": "SizeSelection-module-scss-module__aVyYvW__errorMessage",
  "labelRow": "SizeSelection-module-scss-module__aVyYvW__labelRow",
  "sizeSelect": "SizeSelection-module-scss-module__aVyYvW__sizeSelect",
});
